module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vbl-breadcrumb-item"
  }, [(_vm.to) ? _c('span', [_c('router-link', {
    attrs: {
      "to": _vm.to
    }
  }, [_vm._t("default")], 2), _c('span', {
    staticClass: "separator"
  }, [_vm._v(_vm._s(_vm.separator))])], 1) : _c('span', {
    staticClass: "active"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-774647a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblBreadcrumb/src/vblBreadcrumbItem.vue
// module id = 281
// module chunks = 0